import { Editor, Transforms, Element as SlateElement } from 'slate'
import { useSlate } from 'slate-react'
import React from 'react'

import { useColor } from '../../../kiti/components/theme/_hooks/colors'
import { useElementStyle } from './styles'
import EditorIcon from '../EditorIcon'

const LIST_TYPES = ['list', 'numered_list']

const Element = ({ children, attributes, name, ...props }) => {
  const color = useColor('dark3')

  const style = {
    ...useElementStyle(props.element),
    color: color,
    marginTop: 2,
    marginBottom: 2
  }

  if (name === 'list') {
    return (
      <ul style={style} {...attributes}>
        {children}
      </ul>
    )
  }
  return (
    <ol style={style} {...attributes}>
      {children}
    </ol>
  )
}

const ItemElement = ({ children, attributes }) => {
  return <li {...attributes}>{children}</li>
}

const isActive = (editor, name) => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: n => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === name
    })
  )

  return !!match
}

const toggle = (editor, name) => {
  const active = isActive(editor, name)

  Transforms.unwrapNodes(editor, {
    match: n => !Editor.isEditor(n) && SlateElement.isElement(n) && LIST_TYPES.includes(n.type),
    split: true
  })
  Transforms.setNodes(editor, {
    type: !active ? 'list_item' : 'paragraph'
  })
  if (!active) {
    const block = { type: name, children: [] }
    Transforms.wrapNodes(editor, block)
  }
}

const ToggleIcon = ({ icon, name, ...props }) => {
  const editor = useSlate()
  const active = isActive(editor, name)

  return (
    <EditorIcon
      onClick={() => toggle(editor, name)}
      icon={name === 'list' ? 'RiListCheck' : 'RiListOrdered'}
      active={active}
      {...props}
    />
  )
}

const ListPlugin = {
  toggle,
  ToggleIcon,
  Element,
  ItemElement,
  ToggleIcon
}

export default ListPlugin
